import { factoryService, getJsonRequest } from '@chilecompra/react-kit/requests'
import { normalizeDniSlashes } from '../modules/utils/normalizeForeignDni'
import { REACT_APP_API_BASE_URL } from '../config/settings/environment'

/**
 * Get the company managers of the given seller.
 */
export const getCompanyManagersSii = factoryService(({ dni }) => {
  return getJsonRequest(`${REACT_APP_API_BASE_URL}/v1/sii/representante/${normalizeDniSlashes(dni)}`)
})

/**
 * Get the income bracket for a given 'natural' seller dni and year.
 */
export const getIncomeBracket = factoryService(({ dni, year }) => {
  return getJsonRequest(`${REACT_APP_API_BASE_URL}/v2/sii/tramo-renta/${normalizeDniSlashes(dni)}/${year}`)
})

/**
 * Get the sales income for a given 'legal' seller dni and year.
 */
export const getSalesIncome = factoryService(({ dni, year }) => {
  return getJsonRequest(`${REACT_APP_API_BASE_URL}/v2/sii/tramo-venta/${normalizeDniSlashes(dni)}/${year}`)
})

/**
 * Gets the seller business data.
 */
export const getSellerBusiness = factoryService(({ dni }) => {
  return getJsonRequest(`${REACT_APP_API_BASE_URL}/v1/sii/contribuyente/${normalizeDniSlashes(dni)}`, { retries: 2 })
})

/**
 * Get business activities from SII.
 */
export const getSiiInformation = factoryService(({ dni }) => {
  return getJsonRequest(`${REACT_APP_API_BASE_URL}/v1/sii/actividad-economica/${normalizeDniSlashes(dni)}`)
})

/**
 * Get the start date of activity the given seller.
 */
export const getStartDateActivitySii = factoryService(({ dni }) => {
  return getJsonRequest(`${REACT_APP_API_BASE_URL}/v1/sii/fecha-inicio-actividad/${normalizeDniSlashes(dni)}`)
})

/**
 * Get the tax annotations of the given seller.
 */
export const getTaxAnnotationsSii = factoryService(({ dni }) => {
  return getJsonRequest(`${REACT_APP_API_BASE_URL}/v1/sii/anotaciones/${normalizeDniSlashes(dni)}`)
})

/**
 * Gets the seller business size data.
 */
export const getSellerBusinessSize = factoryService(({ dni }) =>
  getJsonRequest(`${REACT_APP_API_BASE_URL}/v1/emt?rut=${normalizeDniSlashes(dni)}`, { retries: 2 })
)
/**
 * Gets the seller business membership data.
 */
export const getSellerBusinessMembership = factoryService(() =>
  getJsonRequest(`${REACT_APP_API_BASE_URL}/v1/boton-pago/membresia/sii`, { retries: 2 })
)
